<template>
  <div>
    <Head title="Tambah Persyaratan" />
    <h1 class="mb-8 text-2xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/persyaratans">Persyaratan</Link>
      <span class="font-medium text-indigo-400">/</span> Tambah Data
    </h1>
    <div class="w-full overflow-hidden bg-white rounded-md shadow">
      <form @submit.prevent="store">
        <div class="flex flex-wrap p-8 -mb-8 -mr-6">
          <text-input v-model="form.nama" :error="form.errors.nama" class="w-full pb-8 pr-6" label="Nama Persyaratan" />
          <div class="flex w-full pb-8 pr-6 lg:w-1/3">
            <input id="mou_prestasi" v-model="form.mou_prestasi" type="checkbox" class="mr-2" />
            <label for="mou_prestasi" class="flex flex-row items-center cursor-pointer">
              Prestasi
            </label>
          </div>
          <div class="flex w-full pb-8 pr-6 lg:w-1/3">
            <input id="mou_nonprestasi" v-model="form.mou_nonprestasi" type="checkbox" class="mr-2" />
            <label for="mou_nonprestasi" class="flex flex-row items-center cursor-pointer">
              Pra-Sejahtera
            </label>
          </div>
        </div>
        <div class="flex items-center justify-end px-8 py-4 border-t border-gray-100 bg-gray-50">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">
            <font-awesome-icon class="mr-2" icon="fas fa-key" />Simpan
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    TextInput,
  },
  layout: Layout,
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        nama: null,
        mou_prestasi: true,
        mou_nonprestasi: true,
        mandiri: true,
      }),
    }
  },
  methods: {
    store() {
      this.form.post(this.route('persyaratans.store'))
    },
  },
}
</script>
